import { DrawMode } from '@/entities/canvas';
import { RelativeVector2d } from '@/entities/collection';
import { useAppSelector } from '@/shared/hooks';
import { VIDEO_ASPECT_RATIO } from '@/shared/lib';
import { Image, Rect } from 'react-konva';
import useImage from 'use-image';

export function BgRectangle() {
  const canvasDimensions = useAppSelector((state) => state.canvas.dimensions);
  const bgRectangle = useAppSelector((state) => state.canvas.bgRectangle);
  const isBgDrawing = useAppSelector(
    (state) => state.canvas.drawMode === DrawMode.Background
  );

  const [plusIcon] = useImage('/yellow-circle.svg');

  if (!isBgDrawing || !bgRectangle) return null;

  const topLeftX = bgRectangle.topLeft.relativeX * canvasDimensions.canvasWidth;
  const topLeftY =
    bgRectangle.topLeft.relativeY *
    (canvasDimensions.canvasWidth / VIDEO_ASPECT_RATIO);
  const bottomRightX = (bottomRight: RelativeVector2d) =>
    bottomRight.relativeX * canvasDimensions.canvasWidth;
  const bottomRightY = (bottomRight: RelativeVector2d) =>
    bottomRight.relativeY * (canvasDimensions.canvasWidth / VIDEO_ASPECT_RATIO);

  return (
    <>
      {bgRectangle.bottomRight && (
        <>
          <Rect
            x={topLeftX}
            y={topLeftY}
            width={bottomRightX(bgRectangle.bottomRight) - topLeftX}
            height={bottomRightY(bgRectangle.bottomRight) - topLeftY}
            fill="transparent"
            stroke="red"
            strokeWidth={1.5}
          />
          <Image
            width={14}
            height={14}
            x={bottomRightX(bgRectangle.bottomRight) - 7}
            y={bottomRightY(bgRectangle.bottomRight) - 7}
            image={plusIcon}
          />
        </>
      )}
      <Image
        width={14}
        height={14}
        x={topLeftX - 7}
        y={topLeftY - 7}
        image={plusIcon}
      />
    </>
  );
}
